module.exports = __webpack_public_path__ + "img/home_business_item2.faefd01e.jpg";